export { EditorRestrictionsEntryPoint } from './editorRestrictionsEntryPoint';
export { withRestrictions, WithRestrictionsRender } from './withRestrictions';
export { useUXResourceRestrictions } from './useUXResourceRestrictions';
export { allowed } from './editorRestrictionsApi';

export type { UIResourceRestriction } from './editorRestrictionsApi';
